<template>
	<div>
		<template v-for="(prop, index) in offersChooser">
			<div class="b-detail__title" v-html="prop.name"></div>
			<div class="b-detail__wrap">
				<div class="b-packing b-packing_detail">
					<div class="b-packing__item"
					     :class="{selected: (isSelectedOffersOption(option.id, prop.id))}"
					     v-for="option in prop.options"
					     :key="option.id"
					     v-html="option.name"
					     @click.prevent="chooseOffers(option.id, prop.id, index)"
					></div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "CitrusProductOffersChooser",
	props: {
		offersChooser: {
			type: [Array, Object, Boolean],
			default: () => {
				return [];
			}
		},
		offers: {
			type: [Array, Object],
			default: () => []
		},
		offer: {
			type: [Object],
			default: () => {
				return {};
			}
		}
	},
	data: function () {
		return {
			propMatrix: {},
		};
	},
	created() {
		this.propMatrix = this.offer.prop_matrix;
	},
	methods: {
		/**
		 * Обработка выбора торгового предложения
		 */
		chooseOffers: function (optionId, propertyId, index) {
			try {
				let newSelected = Object.assign({}, this.offer.prop_matrix);
				newSelected['PROP_' + propertyId] = optionId;

				if (JSON.stringify(this.offer.prop_matrix) === JSON.stringify(newSelected)) {
					return;
				}

				let offer = this.getOfferByProperty(optionId, propertyId, index);

				if (offer && offer.hasOwnProperty("id")
					&& offer.id
					&& offer.id !== this.offer.id
				) {
					this.$emit("change", {offer: offer});
					this.propMatrix = offer.prop_matrix;
				} else {
					let prop_matrix = Object.assign({}, this.offer.prop_matrix);
					prop_matrix['PROP_' + propertyId] = optionId;

					this.propMatrix = prop_matrix;
					this.$emit("change", {offer: false, prop_matrix: prop_matrix});
				}
			} catch (e) {
				console.warn(e);
			}
		},
		/**
		 * Возвращает true, если в выбранном ТП есть указанное значение сво-ва
		 */
		isSelectedOffersOption: function (optionId, propertyId) {
			return this.offer.hasOwnProperty('prop_matrix')
				&& this.offer.prop_matrix.hasOwnProperty('PROP_' + propertyId)
				&& this.offer.prop_matrix['PROP_' + propertyId] === optionId;
		},
		/**
		 * Возвращает ТП по выбираемому значению сво-ва
		 * (Остальные сво-ва ТП берутся уже выбранные)
		 *
		 * @param optionId
		 * @param propertyId
		 * @param index
		 * @returns {*}
		 */
		getOfferByProperty: function (optionId, propertyId, index) {
			let newSelected = Object.assign({}, this.offer.prop_matrix);
			newSelected['PROP_' + propertyId] = optionId;

			/**
			 * Найдем ТП с полным совпадением свойств
			 */
			let filtered = this.offers.filter(offer => {
				/**
				 * @todo заменить сравнение объектов на корректное
				 * (это сравнение только для простых объектов, с учетом сортировки свой-в в объекте)
				 */
				return JSON.stringify(offer.prop_matrix) === JSON.stringify(newSelected);
			});

			if (filtered.length > 0)
				return filtered[0];

			/**
			 * Найдем ТП с неполным совпадением св-в, чтобы при изменении основного св-ва найти существующее ТП с другим св-ом
			 */
			if (index === 0) {
				filtered = this.offers.filter(offer => {
					return offer.prop_matrix['PROP_' + propertyId] === optionId;
				});
			}

			return (filtered.length > 0) ? filtered[0] : false;
		},
	}
}
</script>